import { useState } from "react";
import {
  createTable,
  createPivotTable,
  getPivotTable,
  getTable,
  deletTheTable,
  updateTheTable,
} from "../services/pivotTableService";

export const usePivot = () => {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const createTheTable = async (
    tableName,
    datasetId,
    selectedCols,
    selectedCoun
  ) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await createTable(
        tableName,
        datasetId,
        selectedCols,
        selectedCoun
      );
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while creating the table.";
    }
  };

  const createThePivot = async (pivotConfig) => {
    setIsLoading(true);
    setError(false);

    try {
      const response = await createPivotTable(pivotConfig);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while creating the pivot table.";
    }
  };

  const getThePivot = async (pivotID) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await getPivotTable(pivotID);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while getting pivot table.";
    }
  };

  const getTheTable = async (tableId) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await getTable(tableId);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while getting table using table ID";
    }
  };

  const deletTable = async (tableId) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await deletTheTable(tableId);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while deleting table using table ID";
    }
  };

  const updateTable = async (tableId, updateData) => {
    setIsLoading(true);
    setError(false);
    try {
      const response = await updateTheTable(tableId, updateData);
      setIsLoading(false);
      return response;
    } catch (error) {
      setIsLoading(false);
      setError(true);
      return "Something went wrong while updating table using table ID";
    }
  };

  return {
    createTheTable,
    createThePivot,
    getThePivot,
    isLoading,
    error,
    getTheTable,
    deletTable,
    updateTable,
  };
};
